import cockpitImageSlider from './modules/cockpitImageSlider'
import googleMapsLocation from './modules/googleMapsLocation'
import cockpitContactForm from './modules/cockpitContactForm'
import cockpitStageSlider from './modules/cockpitStageSlider'

export default {
  addBehaviors: function(behaviors) {
    behaviors.push(cockpitImageSlider)
    behaviors.push(googleMapsLocation)
    behaviors.push(cockpitContactForm)
    behaviors.push(cockpitStageSlider)
    return behaviors;
  },

  tracking: null,
  setTracking: function(tracking) {
    this.tracking = tracking
  },
  getTracking: function() {
    return this.tracking;
  }
}